import { select } from "../core/dom";

const CV_PATH = "/assets/documents/Armin-Lisic-CV.pdf";

export function initCvDownload(): void {
  const button = select<HTMLButtonElement>("#download-cv");
  if (!button) return;

  button.addEventListener("click", () => {
    const link = document.createElement("a");
    link.href = CV_PATH;
    link.download = "Armin-Lisic-CV.pdf";
    document.body.append(link);
    link.click();
    link.remove();
  });
}
